// extracted by mini-css-extract-plugin
export var root = "X_xW";
export var wrapper = "X_sW";
export var image = "X_xX d_w d_y d_W";
export var imageWithHeight = "X_xY";
export var crop = "X_xZ";
export var round = "X_x0";
export var fixedHeight = "X_x1";